"use strict";

var blocksToHyperScript = require('@sanity/block-content-to-hyperscript');

var h = blocksToHyperScript.renderNode;

var blocksToHtml = function blocksToHtml(options) {
  var rootNode = blocksToHyperScript(options);
  return rootNode.outerHTML || rootNode;
};

blocksToHtml.defaultSerializers = blocksToHyperScript.defaultSerializers;
blocksToHtml.getImageUrl = blocksToHyperScript.getImageUrl;
blocksToHtml.renderNode = h;
blocksToHtml.h = h;
module.exports = blocksToHtml;